import { ProductTableRow } from "@pdf/export-services/product-information-pages/product-list-pages/product-table-row";
import { TableColumn } from "@pdf/helpers/default-table/table-column";
import { jsPDF } from "jspdf";
import { ProductListPlaceholderRow } from "./product-list-placeholder-row";
import { ProductListProductRow } from "./product-list-product-row";

export class ProductListRowHeaders {
  public readonly NUMBER = $localize`:@@pdfExport.productList.tableHeader.number:Nr.`;
  public readonly QUANTITY = $localize`:@@pdfExport.productList.tableHeader.quantity:Menge`;
  public readonly DESCRIPTION = $localize`:@@pdfExport.productList.tableHeader.description:Beschreibung`;
  public readonly ID = $localize`:@@pdfExport.productList.tableHeader.partNumber:Sachnummer`;
  public readonly UNIT_PRICE = $localize`:@@pdfExport.productList.tableHeader.pricePerPiece:Stückpreis`;
  public readonly DISCOUNT = $localize`:@@productList.productTable.column.discounts:Rabatt`;
  public readonly TOTAL_PRICE = $localize`:@@pdfExport.productList.tableHeader.totalPrice:Gesamtpreis`;
}

export class ProductTable {
  readonly rowHeaders = new ProductListRowHeaders();
  readonly columns: TableColumn[];
  readonly rows: (ProductListProductRow | ProductListPlaceholderRow)[];
  readonly headline: string;
  readonly showCosts: boolean;
  readonly subTotal?: number;

  constructor(
    pdf: jsPDF,
    localeId: string,
    headline: string,
    productTableRows: ProductTableRow[],
    showCosts: boolean,
    subTotal?: number,
  ) {
    this.headline = headline;
    this.subTotal = subTotal;
    this.showCosts = showCosts;

    this.columns = [
      new TableColumn(this.rowHeaders.NUMBER, 60, 96),
      new TableColumn(this.rowHeaders.QUANTITY, 180, 96),
      new TableColumn(this.rowHeaders.DESCRIPTION, 300, 600),
      new TableColumn(this.rowHeaders.ID, 924, 116),
      ...(showCosts
        ? [
            new TableColumn(this.rowHeaders.UNIT_PRICE, 1180, 116, true),
            new TableColumn(this.rowHeaders.DISCOUNT, 1300, 96, true),
            new TableColumn(this.rowHeaders.TOTAL_PRICE, 1440, 116, true),
          ]
        : []),
    ];

    this.rows = productTableRows.map(
      (productTableRow) => new ProductListProductRow(pdf, localeId, this.columns, productTableRow),
    );
  }
}
